import {Observable} from "rxjs";

export class parserMainClass{
  protected file: File;
  protected type: string;
  protected fileName: string;

  constructor(file) {
    this.__init(file);
  }
  protected __init(file){
    this.file = file;
    this.type = file.name.split('.').pop();
    this.fileName = file.name;
  }

  public getData():Observable<any>{throw new Error('getData not implemented')}
  public getFileOptions():any { return {name: this.fileName, type: this.type, size: this.file.size}};
  public getConfigFromTrackList(trackList):{[key: string]:{id: string, name: string, positions: any[], tool:any}}{throw new Error('getConfigFromTrackList not implemented')}
  protected isAllowedType(){throw new Error('isAllowedType not implemented')}

}

